export enum DossierStatuses {
  OPEN = 'OPEN',
  REOPEN = 'REOPEN',
  CLOSED = 'CLOSED',
  REVOKED = 'REVOKED',
  DELETED = 'DELETED',
}
